module.exports = __webpack_public_path__ + "static/media/abcuniv.edec07d3.png";